import * as types from './actionTypes';

// Regular action creators
export function fetchInitStateRequest(credentials) {
  return {
    type: types.FETCH_INIT_STATE_REQUEST,
    credentials,
  };
}

export function fetchInitStateSuccess(data) {
  return {
    type: types.FETCH_INIT_STATE_SUCCESS,
    data,
  };
}

export function fetchInitStateFail(error) {
  return {
    type: types.FETCH_INIT_STATE_FAIL,
    error,
  };
}

// frequency
export function fetchFrequency(credentials) {
  return {
    type: types.FETCH_FREQUENCY_REQUEST,
    credentials,
  };
}

export function fetchFrequencySuccess(data) {
  return {
    type: types.FETCH_FREQUENCY_SUCCESS,
    data,
  };
}

export function fetchFrequencyFail(error) {
  return {
    type: types.FETCH_FREQUENCY_FAIL,
    error,
  };
}
// clauses
export function fetchClauses(credentials) {
  return {
    type: types.FETCH_CLAUSES_REQUEST,
    credentials,
  };
}

export function fetchClausesSuccess(data) {
  return {
    type: types.FETCH_CLAUSES_SUCCESS,
    data,
  };
}

export function fetchClausesFail(error) {
  return {
    type: types.FETCH_CLAUSES_FAIL,
    error,
  };
}

// icons
export function fetchIcons() {
  return {
    type: types.FETCH_ICONS_REQUEST,
  };
}

export function fetchIconsSuccess({ data }) {
  return {
    type: types.FETCH_ICONS_SUCCESS,
    data,
  };
}

export function fetchIconsFail({ error }) {
  return {
    type: types.FETCH_ICONS_FAIL,
    error,
  };
}

export const fetchUserLanguage = ({ pref }) => ({
  type: types.FETCH_USER_LANGUAGE,
  data: pref,
});

export const updateMenuDrawerSettings = settings => ({
  type: types.UPDATE_MENUDRAWER_SETTINGS,
  settings,
});

export const toggleAbout = toggle => ({
  type: types.TOGGLE_ABOUT,
  toggle,
});

// Fetch services infos
export function fetchServiceInfoRequest() {
  return {
    type: types.FETCH_SERVICEINFO_REQUEST,
  };
}

export function fetchServiceInfoSuccess(data) {
  return {
    type: types.FETCH_SERVICEINFO_SUCCESS,
    data,
  };
}

export function fetchServiceInfoFail(error) {
  return {
    type: types.FETCH_SERVICEINFO_FAIL,
    error,
  };
}
